import { render, staticRenderFns } from "./SrdInformation.vue?vue&type=template&id=8b5dfd98&scoped=true"
import script from "./SrdInformation.vue?vue&type=script&lang=js"
export * from "./SrdInformation.vue?vue&type=script&lang=js"
import style0 from "./SrdInformation.vue?vue&type=style&index=0&id=8b5dfd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5dfd98",
  null
  
)

export default component.exports